(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfCenterDialog', [
    '$window', '$timeout', '$parse', function($window, $timeout, $parse) {
      return {
        link: function(scope, ele, attrs) {
          var opts, sizingOpts;
          sizingOpts = attrs.mfCenterDialog;
          opts = $parse(sizingOpts)(scope);
          return $timeout((function(_this) {
            return function() {
              var dialogHeight, dialogWidth, dlg, heightDiff, pos, widthDiff, windowHeight, windowWidth;
              dlg = ele.closest('[uib-modal-window]');
              pos = {
                margin: '0px',
                top: 'auto',
                bottom: 'auto',
                left: 'auto',
                right: 'auto'
              };
              windowWidth = angular.element($window).width();
              dialogWidth = dlg.outerWidth();
              widthDiff = windowWidth - dialogWidth;
              if (widthDiff < 0) {
                pos.left = widthDiff;
              } else {
                pos.left = widthDiff / 2;
              }
              pos.left += 'px';
              windowHeight = angular.element($window).height();
              dialogHeight = dlg.outerHeight();
              heightDiff = windowHeight - dialogHeight;
              if (heightDiff < 0) {
                pos.top = heightDiff;
              } else {
                pos.top = heightDiff / 2;
              }
              if ((opts != null ? opts.topOffset : void 0) != null) {
                pos.top -= opts.topOffset;
              }
              pos.top += 'px';
              return dlg.css(pos);
            };
          })(this));
        }
      };
    }
  ]);

}).call(this);
